import { createAction, props } from '@ngrx/store';
import { TransferEmplacementHistoryModel } from '@shared/data-access/models';

export const getList = createAction('[Transfer Emplacement History] GET LIST', props<{ payload: TransferEmplacementHistoryModel[] }>());
